import * as React from "react";
const SvgThumbsUpOutline = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M6 8.4 8.4 3a1.8 1.8 0 0 1 1.8 1.8v2.4h3.396a1.2 1.2 0 0 1 1.2 1.38l-.828 5.4a1.2 1.2 0 0 1-1.2 1.02H6m0-6.6V15m0-6.6H4.2A1.2 1.2 0 0 0 3 9.6v4.2A1.2 1.2 0 0 0 4.2 15H6"
    />
  </svg>
);
export default SvgThumbsUpOutline;
